import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Labels } from '@core/constants/labels';
import { IntegrationUpdateService } from '@core/services/integration-update-service/integration-update-service.service';
@Component({
  selector: 'app-log-view',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './log-view.component.html',
  styleUrl: './log-view.component.scss',
})
export class LogViewComponent {
  labels = Labels.INTEGRATION_LOG;
  log = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<LogViewComponent>,
    private integrationUpdateLogService: IntegrationUpdateService,
  ) {}

  ngOnInit() {
    console.log('INITIALIZING....');
    this.integrationUpdateLogService
      .getIntegationLogById(this.data.id)
      .subscribe((update) => {
        this.log = update.log;
      });
  }

  onCancel() {
    this.dialogRef.close();
  }
}
